export default __webpack_public_path__ + "static/avatar-e13275f0b4a92bd5db5ce32c9bda18dc.webp";